import React from 'react'
import GlobalSearchState, { GlobalSearchAction } from './GlobalSearchState'

export const GlobalSearchStateContext = React.createContext<GlobalSearchState>(undefined)
export const GlobalSearchDispatchContext = React.createContext<React.Dispatch<GlobalSearchAction>>(undefined)
